import { createAPI } from '../../common'

export default {
  /* 原来部门库是单独写的有很多bug 现在和稿源库和审稿库统一 */
  /* postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qfsnjttjpo', 'post', config),
    getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qfsnjttjpo0bmm', 'get', config) */
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config
    ),

  // 我的经办全部树
  getAllColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0bmm', 'get', config),
  // 我的经办 有权限的树
  getRoleColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0hfuSpmfDpmvnot', 'get', config),
  // 我的经办 保存树节点的操作权限
  postPermissionHandle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0qfsnjttjpot', 'POST', config),
  // 我的经办 树节点的操作权限
  getPermissionHandle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0qfsnjttjpot', 'get', config)
}
